<mat-dialog-actions class="justify-content-between">
    <h4 class="f-s-16 f-w-600 m-b-16">
        {{ 'ENTITY.PATIENT' | translate }}
    </h4>
    <button mat-icon-button class="d-flex justify-content-center" (click)="onClose()">
        <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
    </button>
</mat-dialog-actions>
<mat-tab-group mat-stretch-tabs="false" animationDuration="10ms">
    <mat-tab>
        <ng-template mat-tab-label>
            <div class="d-flex align-items-center">
                <mat-icon>
                    <i-tabler name="building-store" class="icon-20 m-r-8"></i-tabler>
                </mat-icon>
            </div>
            {{ 'ENTITY.PERSONAL' | translate }}
        </ng-template>
        <mat-dialog-content class="mat-typography">
            <app-personal-details [patientDetails]="patientDetails">
            </app-personal-details>
            <app-address-details [patientDetails]="patientDetails" *ngIf="hasAddressOrContact">
            </app-address-details>
        </mat-dialog-content>
    </mat-tab>

    <mat-tab *ngIf="appointmentHistoryFlag">
        <ng-template mat-tab-label>
            <div class="d-flex align-items-center">
                <mat-icon>
                    <i-tabler name="file-description" class="icon-20 m-r-8"></i-tabler>
                </mat-icon>
            </div>
            {{ 'ENTITY.PATIENT' | translate }} {{ 'ENTITY.APPOINTMENT' | translate }}
        </ng-template>
        <ng-template matTabContent>
            <mat-card-content class="p-y-10">
                <app-patient-appointment-history *ngIf="patientDetails?.id"
                    [patientId]="patientDetails?.id"
                    [patient]="patientDetails"
                    (patientAppointmenthistoryLength)="onHistoryLength($event)"
                    [showOPD]="true">
                </app-patient-appointment-history>
            </mat-card-content>
        </ng-template>
    </mat-tab>

    <mat-tab *ngIf="medicalRecordFlag">
        <ng-template mat-tab-label>
            <div class="d-flex align-items-center">
                <mat-icon>
                    <i-tabler name="folders" class="icon-20 m-r-8"></i-tabler>
                </mat-icon>
            </div>
            {{ 'ENTITY.RECORD' | translate }}
        </ng-template>
        <ng-template matTabContent>
            <mat-card-content class="p-y-10">
                <app-medical-record [patientId]="patientDetails?.id"
                    (medicalRecordLength)="onMedicalRecordLength($event)">
                </app-medical-record>
            </mat-card-content>
        </ng-template>
    </mat-tab>

    <mat-tab *ngIf="showAbdmHealthRecords">
        <ng-template mat-tab-label>
            <div class="d-flex align-items-center">
                <mat-icon>
                    <i-tabler name="heart-rate-monitor" class="icon-20 m-r-8"></i-tabler>
                </mat-icon>
            </div>
            ABDM Health Records
        </ng-template>
        <ng-template matTabContent>
            <mat-card-content class="p-y-10">
                <app-abdm-health-records *ngIf="patientDetails?.id"
                    [patientId]="+patientDetails!.id!">
                </app-abdm-health-records>
            </mat-card-content>
        </ng-template>
    </mat-tab>
</mat-tab-group>
